import {
  AfterViewInit,
  Component,
  ElementRef,
  HostListener,
  Inject,
  Input,
  OnInit,
  PLATFORM_ID,
  ViewChild
} from '@angular/core';
import {CommonModule, DOCUMENT, isPlatformBrowser, ViewportScroller} from '@angular/common';
import {ThemeService} from "../../../services/theme.service";

@Component({
  selector: 'page-navigation',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './page-navigation.component.html',
  styleUrl: './page-navigation.component.scss'
})
export class PageNavigationComponent implements AfterViewInit, OnInit{
  @Input() navigation : { index: number, title:string }[] = [];
  @ViewChild("nav") navigationRef : ElementRef;
  navOffset: number = 0;
  scroll: number = 0;
  constructor(
    private viewportScroller: ViewportScroller,
    @Inject(DOCUMENT) private doc: Document,
    private themeService : ThemeService,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {}

  ngOnInit() {
    this.scroll = 0;
    this.themeService.onResize$.subscribe(()=>{
      this.toggleScrolledClass(this.doc.body.clientTop);
    })
  }

  ngAfterViewInit() {
    const nav = (this.navigationRef.nativeElement as HTMLElement);
    if(nav && nav.getBoundingClientRect){
      const clientRect = nav.getBoundingClientRect();
      nav.classList.remove("scrolled");
      this.navOffset = clientRect.top;
    }
    this.toggleScrolledClass(this.doc.body.clientTop);
  }

  public onNavClick(index: number): void {
    const nav = (this.navigationRef.nativeElement as HTMLElement);
    const headerNav = this.doc.getElementById("HeaderNavbar");
    const section = this.doc.getElementById('Section' + index);

    if(headerNav && section) {
      const sectionClient = section.getBoundingClientRect();
      const offset = headerNav.clientHeight + nav.clientHeight;
      this.scroll = sectionClient.top-offset + window.scrollY;
      if(this.scroll<0)this.scroll = 0;
      this.doc.documentElement.style.scrollBehavior = "smooth";
      this.viewportScroller.scrollToPosition([0,this.scroll]);
      if(isPlatformBrowser(this.platformId)){
        setTimeout(()=>{
          this.doc.documentElement.style.scrollBehavior = "auto";
        },2000)
      }

    }
  }

  toggleScrolledClass(offset : number){
    const nav = (this.navigationRef?.nativeElement as HTMLElement);
    const headerNav = this.doc.getElementById("HeaderNavbar");
    if(headerNav && nav){
      if((this.navOffset < offset + headerNav.clientHeight) || this.themeService.isTablet() || this.themeService.isMobile()){
        nav.classList.add("scrolled");
        nav.getElementsByTagName("ul").item(0)?.classList.add("grid");
        nav.getElementsByTagName("ul").item(0)?.classList.add("grid-section");
        if(this.themeService.isTablet() || this.themeService.isMobile()){
          nav.style.bottom = (headerNav.clientHeight-1)+"px";
          nav.style.top = "auto";
        } else {
          nav.style.top = (headerNav.clientHeight-1)+"px";
          nav.style.bottom = "auto";
        }

      } else {
        nav.classList.remove("scrolled");
        nav.getElementsByTagName("ul").item(0)?.classList.remove("grid");
        nav.getElementsByTagName("ul").item(0)?.classList.remove("grid-section");
      }
    }

  }

  @HostListener('window:scroll', ['$event']) onWindowScroll($event: any) {
    const target = $event.currentTarget ;
    this.toggleScrolledClass(target.scrollY);
  }
}
